import React from 'react';
import { Box, Typography } from '@mui/material';
import { EmailBlock } from './types';
import { emailBuilderBlockBackground } from './blockStyles';
import { RowActions } from './RowActions';

export const SpacerBlock: React.FC<{
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onDragStart: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
}> = ({ isSelected, onSelect, onDelete, onDuplicate, onDragStart, onDragEnd }) => {
  const common = {
    px: 2,
    py: 1.5,
    border: '1px solid',
    borderRadius: 2,
    mx: 1,
    borderColor: isSelected ? 'primary.main' : 'divider',
    backgroundColor: emailBuilderBlockBackground,
    cursor: 'move',
    transition: 'background-color 120ms ease, border-color 120ms ease',
    '&:hover': {
      backgroundColor: 'action.hover',
      borderColor: isSelected ? 'primary.main' : 'primary.light'
    }
  } as const;
  return (
    <Box sx={{ ...common, py: 2 }} draggable onDragStart={onDragStart} onDragEnd={onDragEnd} onClick={onSelect}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="subtitle2" sx={{ mb: 0, wordBreak: 'break-word' }}>Spacer</Typography>
        <RowActions onDelete={onDelete} onDuplicate={onDuplicate} />
      </Box>
    </Box>
  );
};


